import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-progress-stepper',
  templateUrl: './menu-progress-stepper.component.html',
  styleUrls: ['./menu-progress-stepper.component.scss']
})
export class MenuProgressStepperComponent implements OnInit {

  @Input() numberOfSteps;
  @Input() currentIndex = 0;
  @Input() points: boolean;
  lineWidth: number;

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    if (!this.points) {
      this.lineWidth = Math.floor(window.innerWidth / this.numberOfSteps);
      this.elementRef.nativeElement.style.setProperty('--lineWidth', `${this.lineWidth}px`);
    }
  }

  setLine(step: number) {
    if (!this.points) {
      const margin = ((step) * this.lineWidth);
      this.elementRef.nativeElement.style.setProperty('--lineMargin', `${margin}px`);
    }
  }
}
